export const exerciseEditPath = (id: number | string) => `/exercises/${id}/edit`;

export const CataloguePath = {
  Exercises: `/exercises`,
  Exercises_Changes: `/exercises/:name/changes/:group`,
  Templates: `/templates`,
  Templates_New: `/templates/new`,
  Templates_Edit: `/templates/:id/edit`,
  Templates_Changes: `/templates/:name/changes/:group`,
  Lessons: `/lessons`,
  Lessons_New: `/lessons/new`,
  Lessons_Edit: `/lessons/:id/edit`,
  Lessons_Changes: `/lessons/:name/changes/:group`,
};
